import React, { useRef, useState, useEffect, useCallback } from "react";
import { withRouter } from "../../app-services/lib/router-compat";
import view from "./Alert.view";
import "./Alert.css";
import loader from "./loader.gif";

class modalSturct {
  constructor(option = {}) {
    let self = this;
    this.display = false;
    this.title = "";
    this.content = "";
    this.type = "alert";
    this.option = Object.assign(
      {
        ok: "OK",
        cancel: "CANCEL",
        footer: true,
        class: "",
        onOpen: () => { },
      },
      option
    );
    this.promise = new Promise((res, rej) => {
      self.res = res;
      self.rej = rej;
    });
    this.close = (...arg) => {
      this.display = false;
    };
    this.open = () => {
      this.display = true;
    };
  }
}

export function Alert(props) {
  const alertref = useRef(null);
  const [state, setStateRaw] = useState({
    list: [],
  });

  const setState = (partial) => {
    if (typeof partial === "function") {
      setStateRaw(partial);
    } else {
      setStateRaw((prev) => ({ ...prev, ...partial }));
    }
  };

  const instanceRef = useRef(null);
  if (!instanceRef.current) {
    instanceRef.current = {};
  }
  const self = instanceRef.current;

  const handleEscape = useCallback((event) => {
    if (event.key == "Escape") {
      event.preventDefault();
      event.stopPropagation();
    }
  }, []);

  self.removeBodyClass = () => {
    document.querySelector("body").classList = [
      ...document.querySelector("#root").classList,
    ].filter((o) => !o.includes("page-"));
  };

  self.addBodyClass = () => {
    let bookname = self.props.location.pathname.pluck(1);
    self.removeBodyClass();
    document.querySelector("body").classList.add("page-" + bookname);
  };

  self.evalContent = (Content, alertVar) => {
    switch (typeof Content) {
      case "function":
        return Content(alertVar, self);
      default:
        return Content;
    }
  };

  self.alertSuccess = (alertVar) => {
    alertVar.res(alertVar);
    setTimeout(() => {
      alertVar.close();
    });
  };

  self.alertFailure = (alertVar) => {
    alertVar.rej(alertVar);
    setTimeout(() => {
      alertVar.close();
    });
  };

  self.filterList = () => {
    return [].concat(self.state.list.filter((o) => o.display));
  };

  self.loader = (content, header = false) => {
    return self.info(
      <>
        <img src={loader} style={{ width: "100px", height: "100px" }} />
        <br />
        <div dangerouslySetInnerHTML={{ __html: content }} />

      </>,
      header
    );
  };

  self.info = (content, footer = false, header = false) => {
    return self.createDialog(content, header ? "Info" : "", "info", {
      footer: footer,
    });
  };

  self.createDialog = (content, title = "", type = "alert", option = {}) => {
    self.addBodyClass();
    let o = new modalSturct(option);
    o.content = content;
    o.title = title;
    o.display = true;
    o.type = type;
    setTimeout(() => {
      o.option.onOpen(self);
    });
    switch (type) {
      default:
    }
    o.close = () => {
      o.display = false;
      setStateRaw((prev) => ({
        ...prev,
        list: prev.list.filter((item) => item.display),
      }));
    };
    setStateRaw((prev) => ({
      ...prev,
      list: [...prev.list, o],
    }));
    return o;
  };

  Object.assign(self, {
    props,
    state,
    setState,
    alertref,
    handleEscape,
  });

  useEffect(() => {
    document.body.addEventListener("keyup", handleEscape);
    document.body.addEventListener("keydown", handleEscape);

    return () => {
      document.body.removeEventListener("keydown", handleEscape);
      self.removeBodyClass();
    };
  }, [handleEscape]);

  useEffect(() => {
    window.alert = (...args) => self.createDialog(...args);
    window.info = (...args) => self.info(...args);
    window.loader = (...args) => self.loader(...args);
    window.confirm = (content, title, options) =>
      self.createDialog(content, title || "Confirm", "confirm", options || {});
  });

  self.props = props;
  initialConstruct.bind(self)("Modal", props);
  return view.bind(self)(props, props.store, state);
}

export default connect(withRouter(Alert));
